import React from 'react'
import PropTypes from 'prop-types'

import { useSelector } from 'hooks/redux'
import { getFeatureMetadata } from 'selectors/feature/featureMetadata'
import { useDispatch } from 'react-redux'
import {
  navigatorIsFullscreen,
  setSelectedIdWithDrawer,
} from 'actions/navigator'

import { setDrawerVisibleWidth, setDrawerWidth } from 'actions/drawer'
import { DEFAULT_DRAWER_WIDTH } from 'utils/drawerConstants'
import BatchImportSearch from './BatchImportSearch'
import BatchImportReview from './BatchImportReview'
import BatchImportFooter from './BatchImportFooter'
import BatchImportHeader from './BatchImportHeader'

import useBatchImportHook, { SEARCH, SELECT, REVIEW } from './BatchImport.hook'

import { BatchImportContainer } from './BatchImport.styles'

const BatchImport = () => {
  const dispatch = useDispatch()

  // PBI-492348: Get the current feature's part number for the conflict column header
  const { partNumber: currentPartNumber } =
    useSelector(getFeatureMetadata) || {}

  const onClose = () => {
    dispatch(setSelectedIdWithDrawer(null))
    dispatch(navigatorIsFullscreen(false))
    dispatch(setDrawerWidth(DEFAULT_DRAWER_WIDTH))
    dispatch(setDrawerVisibleWidth(DEFAULT_DRAWER_WIDTH))
  }

  const {
    stage,
    selectedFeatureId,
    handleSelectFeature,
    selectedPartNumber,
    buttonConfig,
    logicReviewRowSelectionProps,
    data,
    stepperSteps,
    featureDescription,
    handleCancel,
  } = useBatchImportHook(onClose)

  return (
    <>
      <BatchImportHeader
        handleCancel={handleCancel}
        stage={stage}
        steps={stepperSteps}
        currentPartNumber={currentPartNumber}
      />
      <BatchImportContainer>
        {(stage === SEARCH || stage === SELECT) && (
          <BatchImportSearch
            selected={selectedFeatureId}
            onSelect={handleSelectFeature}
          />
        )}
        {stage === REVIEW && (
          <BatchImportReview
            selectedPartNumber={selectedPartNumber}
            currentPartNumber={currentPartNumber}
            selectedFeatureId={selectedFeatureId}
            logicReviewRowSelectionProps={logicReviewRowSelectionProps}
            data={data}
            featureDescription={featureDescription}
          />
        )}
      </BatchImportContainer>
      <BatchImportFooter buttonConfig={buttonConfig} />
    </>
  )
}

BatchImport.propTypes = {
  onClose: PropTypes.func,
  featureDescription: PropTypes.string,
}

export default BatchImport
